// @ts-ignore
import momentLocalizer from "react-widgets-moment";
import * as Moment from "moment";
// @ts-ignore
import * as React from "react";
// @ts-ignore
import * as ReactDOM from "react-dom";
// @ts-ignore
import { Provider } from "react-redux";
// @ts-ignore
import { BrowserRouter as Router } from "react-router-dom";

import * as Sentry from "@sentry/browser";
import { StripeProvider } from "react-stripe-elements";
import { FetchUserManager } from "./action_managers/account";
import { userLogin } from "./actions/user";
import AppWrapper from "./components/app_wrapper";
import UserStore, { saveUserRole } from "./lib/user_store";
import { unregister } from "./registerServiceWorker";
import configureStore from "./store";

// Bootstrap imports
import "redcircle-brand-css/main.scss";
import { updateCurrentRole } from "./actions/account";
import "./css/ant_designs.less";
import { getStripePublicKey } from "./lib/config";
import { userHasRole } from "./lib/user";
import getDefaultRole from "./lib/user_roles";

require("es6-object-assign/auto");
// TODO - real localization later.
Moment.locale("en");
momentLocalizer();

// uncomment to log places where we can save unnecessary re-renders.
// if (process.env.NODE_ENV !== 'production') {
//     const {whyDidYouUpdate} = require('why-did-you-update')
//     whyDidYouUpdate(React)
// }

// Initialize sentry
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://9f96d8d5096749079e69434d938e2b4b@sentry.io/1432611",
  });
}

const store: any = configureStore();
const user = UserStore.get();
const currentRole = UserStore.getUserRole();
UserStore.saveInviteUUID();
if (user) {
  store.dispatch(userLogin(user));
  if (currentRole && userHasRole(user, currentRole)) {
    store.dispatch(updateCurrentRole(currentRole));
  } else {
    const defaultRole = getDefaultRole(user);
    store.dispatch(updateCurrentRole(defaultRole));
    saveUserRole(defaultRole);
  }
} else {
  UserStore.saveUTMParams();
}

const render = (Component: React.ComponentType) => {
  return ReactDOM.render(
    <Provider store={store}>
      <StripeProvider apiKey={getStripePublicKey()}>
        <Router>
          <Component />
        </Router>
      </StripeProvider>
    </Provider>,
    document.getElementById("root")
  );
};

if (user && user.uuid && user.authToken) {
  store.dispatch(userLogin(user));
  // Will need to figure out how to get redux thunk
  // to work with TS.
  const fetcher: any = new FetchUserManager({
    userUUID: user.uuid,
    authToken: user.authToken,
  }).run();
  store.dispatch(fetcher).then(() => {
    render(AppWrapper);
  });
} else {
  render(AppWrapper);
}

if ((module as any).hot) {
  (module as any).hot.accept("./components/app_wrapper", () => {
    const NextApp = require("./components/app_wrapper").default;
    render(NextApp);
  });
}

unregister();
